import { useAsync } from '@arcxmoney/arcx-react'
import { BigNumber } from 'ethers'
import { useContext } from 'react'
import { RewardPoolDetails } from 'src/config/Config'
import { ArcContext } from 'src/contexts/ArcContext'
import { ArcFarmFactory } from 'src/models/ArcFarmFactory'

interface ITableRowInfo {
  name: string
  pair: string
  platform: string
  totalRewards: string
  earnedAmount: string
  apys: BigNumber[]
  isRewardPeriodFinished: boolean
}

export function useFarmTableRow(farmDetails: RewardPoolDetails): ITableRowInfo {
  const { arc, network, isPlaynetActivated, client } = useContext(ArcContext)
  const signer = arc?.signer

  const [tableRowInfo] = useAsync<ITableRowInfo>(async () => {
    if (!signer) return undefined

    const arcFarm = ArcFarmFactory.new(farmDetails, signer, network, client, isPlaynetActivated)
    try {
      return {
        name: arcFarm.name,
        pair: arcFarm.pair,
        platform: arcFarm.platform,
        totalRewards: await arcFarm.getTotalRewardsString(),
        earnedAmount: await arcFarm.getEarningsString(),
        apys: await arcFarm.getApys(),
        isRewardPeriodFinished: await arcFarm.isRewardPeriodFinished(),
      }
    } catch (err) {
      console.warn(`Err getting the farm info for ${farmDetails.name}: ${err}`)
    }
  }, [network, isPlaynetActivated, signer])

  return tableRowInfo
}
